import { render, staticRenderFns } from "./BranchesList.vue?vue&type=template&id=2da036d1&"
import script from "./BranchesList.vue?vue&type=script&lang=js&"
export * from "./BranchesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports